module.exports = __webpack_public_path__ + "img/66.4e1e6183.jpg";